import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  CANCEL,
  CANCEL_SUCCESS,
  CANCEL_FAILED,
  CHECK_IN_ATTENDEE,
  CHECK_IN_ATTENDEE_SUCCESS,
  CHECK_IN_ATTENDEE_FAILED,
  TOGGLE_EMAIL_ATTENDEES_OVERLAY,
  TOGGLE_ADD_ATTENDEES_OVERLAY,
  TOGGLE_INVITE_ATTENDEES_OVERLAY,
  TOGGLE_FORM_RESPONSES_OVERLAY,
  TOGGLE_FORM_AGGREGATIONS_OVERLAY,
  REMOVE_INVITEE,
  REMOVE_INVITEE_SUCCESS,
  REMOVE_INVITEE_FAILED,
  REMOVE_ATTENDEE,
  REMOVE_ATTENDEE_SUCCESS,
  REMOVE_ATTENDEE_FAILED,
  SET_USER_ROLE_STATUS,
  SET_USER_ROLE_STATUS_SUCCESS,
  SET_USER_ROLE_STATUS_FAILED,
  COMPLETE_MILESTONE,
  COMPLETE_MILESTONE_SUCCESS,
  COMPLETE_MILESTONE_FAILED,
  GET_VOLUNTEER_TIMES,
  APPROVE_VOLUNTEER_TIME,
  DENY_VOLUNTEER_TIME,
  RESPOND_VOLUNTEER_TIME_SUCCESS,
  RESPOND_VOLUNTEER_TIME_FAILED,
  SET_PROJECT_STARTED,
  SET_PROJECT_STARTED_SUCCESS,
  SET_PROJECT_STARTED_FAILED,
  SET_OPT_IN_STATUS,
  SET_OPT_IN_STATUS_SUCCESS,
  SET_OPT_IN_STATUS_FAILED,
} from './constants';

export const initAction = (id) => ({
  type: INIT,
  id,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error, errorCode) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const cancelAction = (deed) => ({
  type: CANCEL,
  deed,
});
export const cancelSuccessAction = () => ({
  type: CANCEL_SUCCESS,
});
export const cancelFailedAction = (error, errorCode) => ({
  type: CANCEL_FAILED,
  error,
  errorCode,
});

export const checkInAttendeeAction = (deedId, userId, existingCheckIns) => ({
  type: CHECK_IN_ATTENDEE,
  deedId,
  userId,
  existingCheckIns,
});
export const checkInAttendeeSuccessAction = () => ({
  type: CHECK_IN_ATTENDEE_SUCCESS,
});
export const checkInAttendeeFailedAction = (error, errorCode) => ({
  type: CHECK_IN_ATTENDEE_FAILED,
  error,
  errorCode,
});

export const toggleEmailAttendeesOverlayAction = (visible) => ({
  type: TOGGLE_EMAIL_ATTENDEES_OVERLAY,
  visible,
});
export const toggleAddAttendeesOverlayAction = (visible) => ({
  type: TOGGLE_ADD_ATTENDEES_OVERLAY,
  visible,
});
export const toggleInviteAttendeesOverlayAction = (visible) => ({
  type: TOGGLE_INVITE_ATTENDEES_OVERLAY,
  visible,
});
export const toggleFormResponsesOverlayAction = (userId) => ({
  type: TOGGLE_FORM_RESPONSES_OVERLAY,
  userId,
});
export const toggleFormAggregationsOverlayAction = (visible) => ({
  type: TOGGLE_FORM_AGGREGATIONS_OVERLAY,
  visible,
});

export const removeInvitee = (deedId, userId) => ({
  type: REMOVE_INVITEE,
  deedId,
  userId,
});
export const removeInviteeSuccessAction = () => ({
  type: REMOVE_INVITEE_SUCCESS,
});
export const removeInviteeFailedAction = (error, errorCode) => ({
  type: REMOVE_INVITEE_FAILED,
  error,
  errorCode,
});

export const removeAttendee = (deedId, userId, roleIds) => ({
  type: REMOVE_ATTENDEE,
  deedId,
  userId,
  roleIds,
});
export const removeAttendeeSuccessAction = () => ({
  type: REMOVE_ATTENDEE_SUCCESS,
});
export const removeAttendeeFailedAction = (error, errorCode) => ({
  type: REMOVE_ATTENDEE_FAILED,
  error,
  errorCode,
});

export const setUserStatusAction = (state, deedId, userId) => ({
  type: SET_USER_ROLE_STATUS,
  state,
  deedId,
  userId,
});

export const setUserStatusSuccessAction = (userId) => ({
  type: SET_USER_ROLE_STATUS_SUCCESS,
  userId,
});

export const setUserStatusFailedAction = (error, userId) => ({
  type: SET_USER_ROLE_STATUS_FAILED,
  error,
  userId,
});

export const completeMilestoneAction = (deedId, milestoneId) => ({
  type: COMPLETE_MILESTONE,
  deedId,
  milestoneId,
});
export const completeMilestoneSuccessAction = () => ({
  type: COMPLETE_MILESTONE_SUCCESS,
});
export const completeMilestoneFailedAction = (error, errorCode) => ({
  type: COMPLETE_MILESTONE_FAILED,
  error,
  errorCode,
});

export const getVolunteerTimes = (id) => ({
  type: GET_VOLUNTEER_TIMES,
  id,
});

export const approveVolunteerTime = (id) => ({
  type: APPROVE_VOLUNTEER_TIME,
  id,
});

export const denyVolunteerTime = (id) => ({
  type: DENY_VOLUNTEER_TIME,
  id,
});

export const respondVolunteerTimeSuccess = (id) => ({
  type: RESPOND_VOLUNTEER_TIME_SUCCESS,
  id,
});
export const respondVolunteerTimeFailed = (id, error) => ({
  type: RESPOND_VOLUNTEER_TIME_FAILED,
  id,
  error,
});

export const setProjectStartedAction = (deed, user) => ({
  type: SET_PROJECT_STARTED,
  deed,
  user,
});
export const setProjectStartedSuccessAction = () => ({
  type: SET_PROJECT_STARTED_SUCCESS,
});
export const setProjectStartedFailedAction = (error, errorCode) => ({
  type: SET_PROJECT_STARTED_FAILED,
  error,
  errorCode,
});

export const setOptInStatusAction = (deed, user, optIn) => ({
  type: SET_OPT_IN_STATUS,
  deed,
  user,
  optIn,
});
export const setOptInStatusSuccessAction = () => ({
  type: SET_OPT_IN_STATUS_SUCCESS,
});
export const setOptInStatusFailedAction = (error, errorCode) => ({
  type: SET_OPT_IN_STATUS_FAILED,
  error,
  errorCode,
});
